function findParent(result){
  if(result){
    if(result.parent == result){
      return result;
    } else {
      return findParent(result.parent)
    }
  } else {
    if(parent == window){
      return window
    } else {
      return findParent(parent)
    }
  }
}

export default findParent
